
import {useCallback, useState} from 'react'
import {backendRequest} from '../../../../../../common/utils/requests'

export type UpdateProviderBody = {
  isProviding?: boolean
  performanceFee?: number
  password?: string
}

type UseUpdateProviderParams = {
  onSuccess: (body: UpdateProviderBody) => Promise<void>
  onError: (body: UpdateProviderBody, error: unknown) => void
}

type UseUpdateProviderReturnValue = {
  loading: boolean
  updateProvider: (body: UpdateProviderBody) => Promise<void>
}

export class ApiError extends Error {
  constructor(message?: string, public payload?: any) {
    super(message)
    this.name = 'ApiError'
    this.payload = payload
  }
}


const fetchAPI = async (accountId: number, body: UpdateProviderBody): Promise<void> => {
  const response = await backendRequest(`/api/v2/dashboard/accounts/${accountId}/providers/brokeree`, body, 'PATCH')

  if (!response.ok) {
    const errorPayload = await response.json()
    throw new ApiError(`Failed to toggle provider ${response.status} ${response.statusText} ${JSON.stringify(errorPayload)}`, errorPayload)
  }
}

export const useUpdateProvider = (accountId: number, params: UseUpdateProviderParams): UseUpdateProviderReturnValue => {
  const {onSuccess, onError} = params

  const [loading, setLoading] = useState(false)

  const updateProvider = useCallback(async (body: UpdateProviderBody) => {
    try {
      setLoading(true)
      await fetchAPI(accountId, body)
      await onSuccess(body)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error fetching me:', e)
      onError(body, e)
    } finally {
      setLoading(false)
    }
  }, [accountId, onError, onSuccess])

  return {loading, updateProvider}
}
